/**
 * https://ui.shadcn.com/docs/components/toast
 */
import { useToast } from "../hooks/use-toast";
import { Toast, ToastProvider, ToastTitle, ToastViewport } from "./toast";
import { ToastIcon } from "./toast";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(({ id, icon, title, theme, ...props }) => (
        <Toast key={id} theme={theme} {...props}>
          {icon && <ToastIcon className={`inline-block size-4 ${icon}`} />}
          {title && <ToastTitle>{title}</ToastTitle>}
        </Toast>
      ))}
      <ToastViewport />
    </ToastProvider>
  );
}
